import { render } from "./EditCell.vue?vue&type=template&id=23008be2"
import script from "./EditCell.vue?vue&type=script&lang=js"
export * from "./EditCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__